import constants from "../../config/constants";

const $inject = ['$window', '$rootScope', '$scope', '$location', '$routeParams', '$timeout', 'dataService', 'settingsService', 'microApiService', 'dataSourceService'];

const lbaResourceCtrl = function ($window, $rootScope, $scope, $location, $routeParams, $timeout, dataService, settingsService, microApiService, dataSourceService) {
  $timeout(() => {
    $window.scrollTo(0, 0);
  });

  const vm = this;
  vm.save = save;
  vm.cancel = cancel;
  vm.delete = deleteItem;
  vm.ready = false;
  vm.fields = settingsService.settings.fields;
  vm.deleteConfirm = false;
  vm.cancelConfirm = false;
  vm.itemAdded = false;
  vm.dataService = dataService;
  vm.showCancel = dataService.addNewMode;
  vm.addNew = addNew;
  vm.cancelNew = cancelNew;
  vm.activeConditionalItem;

  function processData(res) {
    dataService.data.activeItem = res.data;
    vm.ready = true;
  }

  function processPutResponse(res) {
    console.log('res: ', res);
  }

  if (dataService.addNewMode) {
    dataService.cleanDataOnRouteChange = true;
    vm.activeData = dataService.data.activeItem;
    vm.activeItemCopy = angular.copy(dataService.data.activeItem);
  }

  if (!dataService.data.activeItem || dataService.refreshDataOnLoad) {
    dataService.refreshDataOnLoad = false;

    if (vm.settings.microService) {
      dataSourceService.dataSource = constants.DATA_SOURCES.AUTH_ZERO;
      microApiService.get({
        endpoint: `${vm.settings.endpoint}/${$routeParams[vm.settings.routeParamId]}`,
        cb: processData
      })
    } else {
      const ODataArgs = vm.settings.ODataArgs || '';
      dataService.get(vm.settings.endpoint, $routeParams[vm.settings.routeParamId], ODataArgs).then((data) => {
        if (Array.isArray(data)) {
          dataService.data.activeItem = data[0];
        } else {
          dataService.data.activeItem = data;
        }

        if (vm.settings.hasConditionalChildren) {
          var conditionalPropertyValue = getConditionalPropertyValue();
          if (conditionalPropertyValue !== undefined && conditionalPropertyValue !== null) {
            setActiveConditionalItem(conditionalPropertyValue);
          }
        }

        vm.ready = true;
      });
    }
  } else {
    vm.ready = true;
  }

  if (vm.settings.hasConditionalChildren) {
    var conditionalPropertyValue = getConditionalPropertyValue();
    if (conditionalPropertyValue !== undefined && conditionalPropertyValue !== null) {
      setActiveConditionalItem(conditionalPropertyValue);
    }

    $scope.$on(vm.settings.conditionalProperty.dataAt + '_ChangeEvent', function (event, data) {
      setActiveConditionalItem(data);
    });
  }

  function getConditionalPropertyValue() {
    var dataLookUp = dataService.spiltDataAt(vm.settings.conditionalProperty.dataAt, $routeParams);
    return _.get(dataService.data.activeItem, dataLookUp);
  }

  function setActiveConditionalItem(dataValue) {
    var index = _.findIndex(vm.settings.conditionalChildren, function (x) { return x.Type == dataValue; });
    if (index !== -1) {
      vm.activeConditionalItem = vm.settings.conditionalChildren[index].Value;
    } else {
      alert("Setting configuration for this type does not yet exist.");
    }
  }

  function save() {
    console.log('save');
    if (!vm.resourceForm.$valid) {
      vm.errors = vm.resourceForm.$error.required;
      vm.formErrors = true;

      $rootScope.$broadcast('lbaLoader:loaderState', { state: 'error' });

      let pristineFormElement = document.querySelector("ng-form.ng-pristine");
      if (pristineFormElement) {
        pristineFormElement.classList.remove("ng-pristine");
        pristineFormElement.classList.add("ng-dirty");
        let invalidRequiredInput = document.querySelector("input.ng-invalid-required");
        if (invalidRequiredInput) invalidRequiredInput.scrollIntoView();
      }

      return false;
    }
    // Refresh reasons for travel for itinerary policies if agency reason codes updated
    if (dataService.data.activeItem.ItineraryPolicies) {
      let itineraryPolicies = dataService.data.activeItem.ItineraryPolicies;
      itineraryPolicies = itineraryPolicies.map((i) => {
        i.ReasonsForTravel = (i.ReasonsForTravel || []).filter(j => dataService.data.activeItem.DebtorAgencyReasonCodes.find(reason => reason.Code === j))
        return i;
      });
      dataService.data.activeItem.ItineraryPolicies = itineraryPolicies;
    }
    if (vm.settings.microService) {
      console.log('micro');
      microApiService.put({
        endpoint: `${vm.settings.endpoint}/${$routeParams[vm.settings.routeParamId]}`,
        data: dataService.data.activeItem,
        cb: processPutResponse
      })

    } else {
      /* 09/02/2021 - Remove null items from ItineraryPolicies > Flight > Policies
        (they are causing 500 errors LB) */
      if (dataService.data.activeItem.ItineraryPolicies) {
        let itineraryPolicies = dataService.data.activeItem.ItineraryPolicies;
        itineraryPolicies = itineraryPolicies.map((i) => {
          if (i.Flight && i.Flight.Policies) {
            i.Flight.Policies = i.Flight.Policies.filter((y) => {
              if (y != null) return true;
            });
          }
          return i;
        });
        dataService.data.activeItem.ItineraryPolicies = itineraryPolicies;
      }

      return dataService.post(vm.settings.endpoint, dataService.data.activeItem);
    }
  }

  function cancel() {
    vm.ready = false;

    dataService.get(vm.settings.endpoint, $routeParams[vm.settings.routeParamId]).then((data) => {
      if (Array.isArray(data)) {
        dataService.data.activeItem = data[0];
      } else {
        dataService.data.activeItem = data;
      }

      if (dataService.backPath) {
        $location.path(dataService.backPath);
        return;
      }

      vm.cancelConfirm = false;
      vm.ready = true;
    });
  }

  function deleteItem() {
    if (!vm.deleteConfirm) {
      vm.deleteConfirm = true;
    } else {
      if (vm.settings.removeParamId === vm.settings.routeParamId) {
        vm.ready = false;
        dataService.delete(vm.settings.endpoint, $routeParams[vm.settings.removeParamId]).then(() => {
          vm.ready = true;
          backPath();
        })
          .catch((err) => {
            console.log(err);
            vm.ready = true;
          });
      }
      else {
        backPath();
      }
    }
  }

  function addNew() {
    dataService.addNewMode = false;
    dataService.cleanDataOnRouteChange = false;
    vm.showCancel = false;
    vm.itemAdded = true;
  }

  function cancelNew() {
    backPath();
  }

  function backPath() {
    const newLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

    if (newLookUp.length > 1) {
      newLookUp.pop();
    }

    const data = _.get(dataService.data.activeItem, newLookUp);
    if (data) {
      data.splice($routeParams[vm.settings.removeParamId], 1);
    }

    if (dataService.backPath) {
      $location.path(dataService.backPath);
    } else {
      const spiltPath = _.split($location.$$path, '/');
      const dropTwoFromPath = _.dropRight(spiltPath, 2);
      const rejoinPath = _.join(dropTwoFromPath, '/');
      $location.path(rejoinPath);
    }
  }
};

lbaResourceCtrl.$inject = $inject;

export default lbaResourceCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaResource/lbaResourceCtrl.js